// Extra i18n content: splash gate, local-journey hero/process, lead-form microcopy,
// header pill and cookie banner. Merged into the base translations at runtime.
// Proper nouns (Fiji, Nadi, Suva, TIN, VAT, PDF, WhatsApp) stay untranslated.

export const extra = {
  en: {
    gate: {
      startHere: "Start here",
      title: "Are you a Fiji citizen or a foreign investor looking to do business in Fiji?",
      sub: "Choose your path and we'll tailor the guidance, timelines and free checklist to you.",
      foreign: { kicker: "01 / Foreign Investor", title: "I'm a foreign investor", desc: "Remote-first onboarding, investor permit prep, and verified 8-step guidance — 7 of 8 steps handled remotely.", badge: "7 of 8 steps remote" },
      local: { kicker: "02 / Fiji Citizen", title: "I'm a Fiji citizen (local)", desc: "A dedicated local journey: company formation, TIN registration and business bank account setup.", badge: "Local journey" },
      continue: "Continue",
    },
    heroLocal: {
      badge: "For Fiji citizens · Nadi & Suva",
      line1: "Set Up Your Business",
      line2: "in Fiji —",
      line3: "The Local Way",
      sub: "Company formation, TIN registration and business banking — handled end-to-end from our offices in Nadi and Suva, with clear timelines and a document checklist so you arrive prepared.",
      caption: "Formation, tax and banking — all handled locally.",
    },
    processLocal: {
      title: "Three steps to set up your company in Fiji.",
      sub: "Here are the stages and realistic timelines. Full fees, document checklists and pricing are in the free guide.",
    },
    formNew: {
      locationLabel: "Location (Country / City)",
      locationPh: "e.g. Sydney, Australia",
      consent: "I consent to receive the emailed PDF checklist, updates, and security alerts.",
      submit: "Email me the Fiji Setup Checklist (PDF)",
      micro: "PDF emailed only · Quote flow triggers once the checklist is confirmed.",
      errConsent: "Please tick the consent box so we can email your checklist.",
      quote: "Request a Quote",
      fallbackTitle: "Your guide is ready to download",
      fallbackText: "We couldn't email your checklist just now — but you can download it directly below, and our team has your details.",
      download: "Download the Checklist (PDF)",
    },
    headerPill: { local: "Fiji citizen", foreign: "Foreign investor", change: "change" },
    cookie: {
      text: "We use essential cookies to make this site work and to understand traffic. By continuing you agree to our use of cookies.",
      accept: "Accept",
      decline: "Decline",
      privacy: "Privacy Policy",
    },
  },

  zh: {
    gate: {
      startHere: "从这里开始",
      title: "您是斐济公民还是希望在斐济经商的外国投资者？",
      sub: "选择您的路径，我们将为您量身定制指南、时间安排和免费清单。",
      foreign: { kicker: "01 / 外国投资者", title: "我是外国投资者", desc: "以远程为先的入门流程、投资者许可准备，以及经过验证的八步指南——8 个步骤中有 7 个可远程办理。", badge: "8步中7步可远程" },
      local: { kicker: "02 / 斐济公民", title: "我是斐济公民（本地）", desc: "专属的本地流程：公司成立、TIN 税号注册以及企业银行账户开设。", badge: "本地流程" },
      continue: "继续",
    },
    heroLocal: {
      badge: "面向斐济公民 · 楠迪与苏瓦",
      line1: "在斐济",
      line2: "开办您的企业 —",
      line3: "本地方式",
      sub: "公司成立、TIN 税号注册与企业银行业务——由我们楠迪和苏瓦的办公室端到端办理，并提供清晰的时间安排和文件清单，让您有备而来。",
      caption: "成立、税务与银行业务——全部本地办理。",
    },
    processLocal: {
      title: "在斐济开办公司的三个步骤。",
      sub: "以下是各阶段及实际所需时间。完整费用、文件清单和价格都在免费指南中。",
    },
    formNew: {
      locationLabel: "所在地（国家 / 城市）",
      locationPh: "例如：澳大利亚，悉尼",
      consent: "我同意接收邮寄的 PDF 清单、更新及安全提醒。",
      submit: "把斐济设立清单（PDF）发给我",
      micro: "仅通过邮件发送 PDF · 清单确认后即启动报价流程。",
      errConsent: "请勾选同意框，以便我们发送清单给您。",
      quote: "申请报价",
      fallbackTitle: "您的指南已可下载",
      fallbackText: "我们暂时无法通过邮件发送清单——但您可以直接在下方下载，我们的团队也已收到您的信息。",
      download: "下载清单（PDF）",
    },
    headerPill: { local: "斐济公民", foreign: "外国投资者", change: "更改" },
    cookie: {
      text: "我们使用必要的 Cookie 以保证网站运行并了解访问情况。继续浏览即表示您同意我们使用 Cookie。",
      accept: "接受",
      decline: "拒绝",
      privacy: "隐私政策",
    },
  },

  hi: {
    gate: {
      startHere: "यहाँ से शुरू करें",
      title: "क्या आप फ़िजी के नागरिक हैं या फ़िजी में व्यवसाय करने के इच्छुक विदेशी निवेशक?",
      sub: "अपना रास्ता चुनें और हम आपके लिए मार्गदर्शन, समय-सीमा और मुफ़्त चेकलिस्ट तैयार करेंगे।",
      foreign: { kicker: "01 / विदेशी निवेशक", title: "मैं एक विदेशी निवेशक हूँ", desc: "रिमोट-फ़र्स्ट ऑनबोर्डिंग, निवेशक परमिट तैयारी और सत्यापित 8-चरण मार्गदर्शन — 8 में से 7 चरण रिमोट संभाले जाते हैं।", badge: "8 में से 7 चरण रिमोट" },
      local: { kicker: "02 / फ़िजी नागरिक", title: "मैं एक फ़िजी नागरिक (स्थानीय) हूँ", desc: "एक समर्पित स्थानीय प्रक्रिया: कंपनी गठन, TIN पंजीकरण और व्यावसायिक बैंक खाता सेटअप।", badge: "स्थानीय प्रक्रिया" },
      continue: "जारी रखें",
    },
    heroLocal: {
      badge: "फ़िजी नागरिकों के लिए · नाडी और सुवा",
      line1: "फ़िजी में अपना",
      line2: "व्यवसाय स्थापित करें —",
      line3: "स्थानीय तरीके से",
      sub: "कंपनी गठन, TIN पंजीकरण और व्यावसायिक बैंकिंग — नाडी और सुवा स्थित हमारे कार्यालयों से अंत तक संभाला गया, स्पष्ट समय-सीमा और दस्तावेज़ चेकलिस्ट के साथ ताकि आप तैयार रहें।",
      caption: "गठन, कर और बैंकिंग — सब स्थानीय रूप से संभाला गया।",
    },
    processLocal: {
      title: "फ़िजी में अपनी कंपनी स्थापित करने के तीन चरण।",
      sub: "यहाँ चरण और वास्तविक समय-सीमाएँ दी गई हैं। पूरी फीस, दस्तावेज़ चेकलिस्ट और मूल्य निर्धारण मुफ़्त गाइड में हैं।",
    },
    formNew: {
      locationLabel: "स्थान (देश / शहर)",
      locationPh: "जैसे सिडनी, ऑस्ट्रेलिया",
      consent: "मैं ईमेल किए गए PDF चेकलिस्ट, अपडेट और सुरक्षा अलर्ट प्राप्त करने की सहमति देता/देती हूँ।",
      submit: "मुझे फ़िजी सेटअप चेकलिस्ट (PDF) ईमेल करें",
      micro: "केवल PDF ईमेल किया जाता है · चेकलिस्ट पुष्टि होने पर कोटेशन प्रक्रिया शुरू होती है।",
      errConsent: "कृपया सहमति बॉक्स पर टिक करें ताकि हम आपकी चेकलिस्ट ईमेल कर सकें।",
      quote: "कोटेशन का अनुरोध करें",
      fallbackTitle: "आपकी गाइड डाउनलोड के लिए तैयार है",
      fallbackText: "हम अभी आपकी चेकलिस्ट ईमेल नहीं कर सके — लेकिन आप इसे नीचे सीधे डाउनलोड कर सकते हैं, और हमारी टीम के पास आपका विवरण है।",
      download: "चेकलिस्ट डाउनलोड करें (PDF)",
    },
    headerPill: { local: "फ़िजी नागरिक", foreign: "विदेशी निवेशक", change: "बदलें" },
    cookie: {
      text: "हम इस साइट को चलाने और ट्रैफ़िक समझने के लिए आवश्यक कुकीज़ का उपयोग करते हैं। जारी रखकर आप हमारी कुकीज़ के उपयोग से सहमत होते हैं।",
      accept: "स्वीकारें",
      decline: "अस्वीकारें",
      privacy: "गोपनीयता नीति",
    },
  },

  ja: {
    gate: {
      startHere: "ここから始める",
      title: "あなたはフィジー国民ですか、それともフィジーでの事業を検討する外国人投資家ですか？",
      sub: "進む道をお選びください。ガイダンス、所要期間、無料チェックリストをあなたに合わせてご用意します。",
      foreign: { kicker: "01 / 外国人投資家", title: "私は外国人投資家です", desc: "リモート前提のオンボーディング、投資家許可の準備、検証済みの8ステップガイダンス — 8ステップ中7ステップはリモートで対応。", badge: "8ステップ中7つがリモート" },
      local: { kicker: "02 / フィジー国民", title: "私はフィジー国民（現地）です", desc: "現地向けの専用フロー：会社設立、TIN登録、法人銀行口座の開設。", badge: "現地向けフロー" },
      continue: "続ける",
    },
    heroLocal: {
      badge: "フィジー国民の方へ · ナンディ＆スバ",
      line1: "フィジーでの",
      line2: "ビジネス設立 —",
      line3: "現地流のやり方",
      sub: "会社設立、TIN登録、法人バンキング — ナンディとスバのオフィスから一貫して対応。明確な所要期間と書類チェックリストで、準備万端で臨めます。",
      caption: "設立・税務・銀行口座 — すべて現地で対応。",
    },
    processLocal: {
      title: "フィジーで会社を設立する3つのステップ。",
      sub: "各段階と現実的な所要期間をご紹介します。詳しい費用、書類チェックリスト、料金は無料ガイドに掲載しています。",
    },
    formNew: {
      locationLabel: "所在地（国 / 都市）",
      locationPh: "例：オーストラリア、シドニー",
      consent: "PDFチェックリスト、最新情報、セキュリティ通知をメールで受け取ることに同意します。",
      submit: "フィジー設立チェックリスト（PDF）をメールで送る",
      micro: "PDFはメール送付のみ · チェックリスト確定後に見積りフローが開始します。",
      errConsent: "チェックリストをお送りできるよう、同意ボックスにチェックを入れてください。",
      quote: "見積りを依頼",
      fallbackTitle: "ガイドをダウンロードいただけます",
      fallbackText: "ただ今メールでチェックリストをお送りできませんでした — 下記から直接ダウンロードいただけます。担当チームにはお客様の情報が届いています。",
      download: "チェックリストをダウンロード（PDF）",
    },
    headerPill: { local: "フィジー国民", foreign: "外国人投資家", change: "変更" },
    cookie: {
      text: "本サイトの動作とアクセス状況の把握のため、必須クッキーを使用します。続行すると、クッキーの使用に同意したものとみなされます。",
      accept: "同意する",
      decline: "拒否する",
      privacy: "プライバシーポリシー",
    },
  },

  ko: {
    gate: {
      startHere: "여기서 시작",
      title: "피지 국민이신가요, 아니면 피지에서 사업을 하려는 외국인 투자자이신가요?",
      sub: "경로를 선택하시면 안내, 소요 기간, 무료 체크리스트를 맞춤으로 제공해 드립니다.",
      foreign: { kicker: "01 / 외국인 투자자", title: "저는 외국인 투자자입니다", desc: "원격 우선 온보딩, 투자자 허가 준비, 검증된 8단계 안내 — 8단계 중 7단계를 원격으로 처리합니다.", badge: "8단계 중 7단계 원격" },
      local: { kicker: "02 / 피지 국민", title: "저는 피지 국민(현지)입니다", desc: "현지 전용 절차: 회사 설립, TIN 등록, 법인 은행 계좌 개설.", badge: "현지 절차" },
      continue: "계속",
    },
    heroLocal: {
      badge: "피지 국민을 위한 · 난디 & 수바",
      line1: "피지에서 사업을",
      line2: "시작하세요 —",
      line3: "현지 방식으로",
      sub: "회사 설립, TIN 등록, 법인 뱅킹 — 난디와 수바 사무소에서 끝까지 처리합니다. 명확한 소요 기간과 서류 체크리스트로 준비된 상태로 시작하세요.",
      caption: "설립·세무·뱅킹 — 모두 현지에서 처리.",
    },
    processLocal: {
      title: "피지에서 회사를 설립하는 3단계.",
      sub: "각 단계와 현실적인 소요 기간입니다. 전체 수수료, 서류 체크리스트, 가격은 무료 가이드에 있습니다.",
    },
    formNew: {
      locationLabel: "위치 (국가 / 도시)",
      locationPh: "예: 호주, 시드니",
      consent: "이메일로 발송되는 PDF 체크리스트, 업데이트, 보안 알림 수신에 동의합니다.",
      submit: "피지 설립 체크리스트(PDF)를 이메일로 보내주세요",
      micro: "PDF는 이메일로만 발송 · 체크리스트 확정 시 견적 절차가 시작됩니다.",
      errConsent: "체크리스트를 보내드릴 수 있도록 동의 상자에 체크해 주세요.",
      quote: "견적 요청",
      fallbackTitle: "가이드를 다운로드할 수 있습니다",
      fallbackText: "지금은 체크리스트를 이메일로 보내드리지 못했습니다 — 아래에서 바로 다운로드하실 수 있으며, 저희 팀이 귀하의 정보를 받았습니다.",
      download: "체크리스트 다운로드 (PDF)",
    },
    headerPill: { local: "피지 국민", foreign: "외국인 투자자", change: "변경" },
    cookie: {
      text: "사이트 작동과 트래픽 파악을 위해 필수 쿠키를 사용합니다. 계속하시면 쿠키 사용에 동의하는 것으로 간주됩니다.",
      accept: "동의",
      decline: "거부",
      privacy: "개인정보처리방침",
    },
  },

  es: {
    gate: {
      startHere: "Empiece aquí",
      title: "¿Es usted ciudadano de Fiyi o un inversor extranjero que desea hacer negocios en Fiyi?",
      sub: "Elija su camino y adaptaremos la guía, los plazos y la lista gratuita a usted.",
      foreign: { kicker: "01 / Inversor extranjero", title: "Soy un inversor extranjero", desc: "Incorporación en remoto, preparación del permiso de inversor y guía verificada de 8 pasos — 7 de 8 pasos se gestionan en remoto.", badge: "7 de 8 pasos en remoto" },
      local: { kicker: "02 / Ciudadano de Fiyi", title: "Soy ciudadano de Fiyi (local)", desc: "Un recorrido local dedicado: constitución de la empresa, registro del TIN y apertura de cuenta bancaria empresarial.", badge: "Recorrido local" },
      continue: "Continuar",
    },
    heroLocal: {
      badge: "Para ciudadanos de Fiyi · Nadi y Suva",
      line1: "Establezca su negocio",
      line2: "en Fiyi —",
      line3: "a la manera local",
      sub: "Constitución de la empresa, registro del TIN y banca empresarial — gestionado de principio a fin desde nuestras oficinas de Nadi y Suva, con plazos claros y una lista de documentos para que llegue preparado.",
      caption: "Constitución, impuestos y banca — todo gestionado localmente.",
    },
    processLocal: {
      title: "Tres pasos para constituir su empresa en Fiyi.",
      sub: "Estas son las etapas y los plazos realistas. Las tarifas completas, las listas de documentos y los precios están en la guía gratuita.",
    },
    formNew: {
      locationLabel: "Ubicación (País / Ciudad)",
      locationPh: "p. ej. Sídney, Australia",
      consent: "Consiento recibir por correo la lista PDF, novedades y alertas de seguridad.",
      submit: "Envíenme la lista de constitución en Fiyi (PDF)",
      micro: "Solo se envía el PDF por correo · El flujo de presupuesto se activa al confirmar la lista.",
      errConsent: "Marque la casilla de consentimiento para poder enviarle su lista.",
      quote: "Solicitar presupuesto",
      fallbackTitle: "Su guía está lista para descargar",
      fallbackText: "No pudimos enviarle la lista por correo en este momento — pero puede descargarla directamente abajo, y nuestro equipo tiene sus datos.",
      download: "Descargar la lista (PDF)",
    },
    headerPill: { local: "Ciudadano de Fiyi", foreign: "Inversor extranjero", change: "cambiar" },
    cookie: {
      text: "Usamos cookies esenciales para que este sitio funcione y para entender el tráfico. Al continuar, acepta nuestro uso de cookies.",
      accept: "Aceptar",
      decline: "Rechazar",
      privacy: "Política de privacidad",
    },
  },

  fr: {
    gate: {
      startHere: "Commencez ici",
      title: "Êtes-vous un citoyen fidjien ou un investisseur étranger souhaitant faire des affaires aux Fidji ?",
      sub: "Choisissez votre parcours et nous adapterons les conseils, les délais et la liste gratuite à votre situation.",
      foreign: { kicker: "01 / Investisseur étranger", title: "Je suis un investisseur étranger", desc: "Intégration à distance, préparation du permis d'investisseur et guide vérifié en 8 étapes — 7 des 8 étapes gérées à distance.", badge: "7 des 8 étapes à distance" },
      local: { kicker: "02 / Citoyen fidjien", title: "Je suis un citoyen fidjien (local)", desc: "Un parcours local dédié : création de la société, enregistrement du TIN et ouverture du compte bancaire professionnel.", badge: "Parcours local" },
      continue: "Continuer",
    },
    heroLocal: {
      badge: "Pour les citoyens fidjiens · Nadi & Suva",
      line1: "Créez votre entreprise",
      line2: "aux Fidji —",
      line3: "à la manière locale",
      sub: "Création de la société, enregistrement du TIN et banque professionnelle — gérés de bout en bout depuis nos bureaux de Nadi et Suva, avec des délais clairs et une liste de documents pour arriver préparé.",
      caption: "Création, fiscalité et banque — tout géré localement.",
    },
    processLocal: {
      title: "Trois étapes pour créer votre société aux Fidji.",
      sub: "Voici les étapes et les délais réalistes. Les frais complets, les listes de documents et les tarifs sont dans le guide gratuit.",
    },
    formNew: {
      locationLabel: "Localisation (Pays / Ville)",
      locationPh: "ex. Sydney, Australie",
      consent: "J'accepte de recevoir par e-mail la liste PDF, les actualités et les alertes de sécurité.",
      submit: "Envoyez-moi la liste de création aux Fidji (PDF)",
      micro: "PDF envoyé par e-mail uniquement · Le flux de devis démarre une fois la liste confirmée.",
      errConsent: "Veuillez cocher la case de consentement pour que nous puissions vous envoyer votre liste.",
      quote: "Demander un devis",
      fallbackTitle: "Votre guide est prêt à télécharger",
      fallbackText: "Nous n'avons pas pu vous envoyer la liste par e-mail pour le moment — mais vous pouvez la télécharger directement ci-dessous, et notre équipe a vos coordonnées.",
      download: "Télécharger la liste (PDF)",
    },
    headerPill: { local: "Citoyen fidjien", foreign: "Investisseur étranger", change: "changer" },
    cookie: {
      text: "Nous utilisons des cookies essentiels pour faire fonctionner ce site et comprendre le trafic. En continuant, vous acceptez notre utilisation des cookies.",
      accept: "Accepter",
      decline: "Refuser",
      privacy: "Politique de confidentialité",
    },
  },

  ar: {
    gate: {
      startHere: "ابدأ من هنا",
      title: "هل أنت مواطن فيجي أم مستثمر أجنبي يتطلع لممارسة الأعمال في فيجي؟",
      sub: "اختر مسارك وسنُصمّم لك الإرشادات والمدد الزمنية والقائمة المجانية.",
      foreign: { kicker: "01 / مستثمر أجنبي", title: "أنا مستثمر أجنبي", desc: "بدء عن بُعد أولاً، وتجهيز تصريح المستثمر، وإرشاد موثّق من 8 خطوات — 7 من 8 خطوات تُنجَز عن بُعد.", badge: "7 من 8 خطوات عن بُعد" },
      local: { kicker: "02 / مواطن فيجي", title: "أنا مواطن فيجي (محلي)", desc: "مسار محلي مخصّص: تأسيس الشركة وتسجيل TIN وفتح الحساب البنكي للشركة.", badge: "مسار محلي" },
      continue: "متابعة",
    },
    heroLocal: {
      badge: "لمواطني فيجي · نادي وسوفا",
      line1: "أسّس عملك",
      line2: "في فيجي —",
      line3: "بالطريقة المحلية",
      sub: "تأسيس الشركة وتسجيل TIN والخدمات البنكية للشركات — بإدارة كاملة من مكتبينا في نادي وسوفا، مع مدد زمنية واضحة وقائمة مستندات لتصل مستعدًا.",
      caption: "التأسيس والضرائب والخدمات البنكية — كلها تُنجَز محليًا.",
    },
    processLocal: {
      title: "ثلاث خطوات لتأسيس شركتك في فيجي.",
      sub: "إليك المراحل والمدد الزمنية الواقعية. أما الرسوم الكاملة وقوائم المستندات والأسعار فتجدها في الدليل المجاني.",
    },
    formNew: {
      locationLabel: "الموقع (الدولة / المدينة)",
      locationPh: "مثال: سيدني، أستراليا",
      consent: "أوافق على تلقّي قائمة PDF والتحديثات وتنبيهات الأمان عبر البريد الإلكتروني.",
      submit: "أرسل لي قائمة التأسيس في فيجي (PDF)",
      micro: "يُرسَل ملف PDF عبر البريد فقط · يبدأ مسار عرض السعر بعد تأكيد القائمة.",
      errConsent: "يرجى تحديد خانة الموافقة كي نتمكن من إرسال قائمتك عبر البريد.",
      quote: "اطلب عرض سعر",
      fallbackTitle: "دليلك جاهز للتنزيل",
      fallbackText: "تعذّر علينا إرسال القائمة عبر البريد الآن — لكن يمكنك تنزيلها مباشرةً أدناه، وفريقنا لديه بياناتك.",
      download: "تنزيل القائمة (PDF)",
    },
    headerPill: { local: "مواطن فيجي", foreign: "مستثمر أجنبي", change: "تغيير" },
    cookie: {
      text: "نستخدم ملفات تعريف الارتباط الأساسية لتشغيل هذا الموقع وفهم حركة الزيارات. بمواصلتك التصفّح فإنك توافق على استخدامنا لها.",
      accept: "أوافق",
      decline: "رفض",
      privacy: "سياسة الخصوصية",
    },
  },
};
